import React, {Component} from "react"
import {Entity} from 'aframe-react'

class ActionButton extends Component {

    constructor(props) {
        super(props)

        this.minOpacity = 0.1
        this.maxOpacity = 1.0

        this.animDur = 100

        this.material = {
            opacity: this.minOpacity,
            flatShading: true,
            side: "front",
        }

        // this.animateIn = {
        //     property: "material.opacity",
        //     dur: 100,

        //     from: iddleOpacity.toString(),
        //     to: maxOpacity.toString(),

        //     startEvents: "mouseenter"
        // }

        // this.animateOut = {
        //     property: "material.opacity",
        //     dur: 100,

        //     from: maxOpacity.toString(),
        //     to: iddleOpacity.toString(),

        //     startEvents: "mouseleave"
        // }
    }

    getAnimation(reverse=false) {
        return (
            <a-animation
                attribute="material.opacity"

                dur={this.animDur}

                from={ (!reverse) ? this.minOpacity : this.maxOpacity }
                to={ !(reverse) ? this.maxOpacity : this.minOpacity }

                begin={ !(reverse) ? "mouseenter" : "mouseleave" }
                end={ !(reverse) ? "mouseleave" : "mouseenter" }

            />
        )
    }

    render() {
        return (
            <Entity
                primitive="a-image"

                material={this.material}
                scale={this.props.scale}

                src={this.props.src}

                position={this.props.position}

                width={this.props.width} height={this.props.height}

                // animation__opacityup={this.animateIn}
                // animation__opacitydown={this.animateOut}
                
                visible={this.props.visible}

                events={this.props.events}

                frame-button={{
                    button: this.props.button,
                }}
            >
                {this.getAnimation()}
                {this.getAnimation(true)}
            </Entity>
        );
    }
}

ActionButton.defaultProps = {
    width: 1,
    height: 1,

    position: {
        x: 0,
        y: 0,
        z: 0,
    },

    scale: {
        x: 1,
        y: 1,
        z: 1,
    },

    visible: true,

    events: {},

    button: false,
}

export default ActionButton


// WEBPACK FOOTER //
// ./src/components/ActionButton.js